// Reorganized entrypoint: keep this file minimal and import core parts
import { defineTopbarElement, autoMount } from './platform';

defineTopbarElement();
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', autoMount, { once: true });
else autoMount();
